// extracted by mini-css-extract-plugin
export default {"root":"InfoBadge-module--root--c2e6b","green":"InfoBadge-module--green--3564f","blue":"InfoBadge-module--blue--4819b","pink":"InfoBadge-module--pink--e8025"};